export const buildVariantUrl = ({
  pathname,
  search,
  variantId,
}: {
  pathname: string
  search: string
  variantId?: string | null
}) => {
  const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search)

  if (variantId) {
    params.set("v_id", variantId)
  } else {
    params.delete("v_id")
  }

  const query = params.toString()
  return query ? `${pathname}?${query}` : pathname
}

export const replaceVariantUrlWithoutNavigation = ({
  pathname,
  variantId,
}: {
  pathname: string
  variantId?: string | null
}) => {
  if (typeof window === "undefined") {
    return
  }

  const nextUrl = `${buildVariantUrl({
    pathname,
    search: window.location.search,
    variantId,
  })}${window.location.hash}`
  const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`

  if (nextUrl !== currentUrl) {
    window.history.replaceState(window.history.state, "", nextUrl)
  }
}
